module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content has-text-centered is-small"
  }, [_c('p', [_c('toggle-dark-theme')], 1), _vm._v(" "), _c('p', [_vm._v("\n          © " + _vm._s(_vm.currentYear) + " leaguepoints.lol - Data provided by the official League of Legends API\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          Leaguepoints. isn’t endorsed by Riot Games and doesn’t reflect the views or opinions of Riot Games or anyone officially involved in producing or managing League of Legends. League of Legends and Riot Games are trademarks or registered trademarks of Riot Games, Inc. League of Legends © Riot Games, Inc.\n        ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c17e4b26","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppFooter.vue
// module id = 408
// module chunks = 1